import type { FaireProductEntity } from "../../entity_types/product";

export const p_vb74wj3mbf: FaireProductEntity = {
  token: "p_vb74wj3mbf",
  type: "product",
  name: "Heart Shaped Pearl Shell Bracelet 18k gold plated",
  brandToken: "b_b5e3cyh82h",
  brandName: "Amady Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/6e19b973dd02ae0ac36250ceb91e67936b91dc8edf573c00b48688384eb244f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e2ace112ffd7e09a14a9382fb81827d3ae2f003eb197a0396c9e4eab5bdeb73b.jpeg",
    "https://cdn.faire.com/fastly/612aaff5de9b0bd1352a6d460b0370603baca8e2ebd504eda62616ffdd4af0d0.jpeg",
    "https://cdn.faire.com/fastly/5983b17cc1acc85a62eec301589061555bf04d5683b5b3fec129c70a67494ff4.jpeg",
    "https://cdn.faire.com/fastly/14e3c77aa200e5f86e19348654d243a92189871a545af2d130018847a1583173.jpeg",
    "https://cdn.faire.com/fastly/5a7e7c570742f385ba23235f95744a6be2fb1264491ab91c84223d4bec12a2c6.jpeg",
    "https://cdn.faire.com/fastly/fc17863b9dc46e0e8611d6a00e916de33d57a30a534af4cfed19b1c71da06b02.jpeg",
    "https://cdn.faire.com/fastly/264e0d4b195d2c101eafa31083b7abf03193970a6f03a7e383f37eab334097af.jpeg",
    "https://cdn.faire.com/fastly/7c1af7b8a9e55a42d7bc2bca4cb48ecf643f8e01602d0d58f08dc4e6d1c8ec89.jpeg",
    "https://cdn.faire.com/fastly/cdc10ae49e08f123cc3e8101c587909b19e313b9f00cfae0e88fb1a134b09f37.jpeg",
    "https://cdn.faire.com/fastly/83f83eac8d7e087d00680799d5d3fbd8a61c6be098f2fcbb643c48dee88ef90b.png",
  ],
  priceDollars: 15,
  description:
    '• Lovely heart shaped shell pearls bracelet. Great to wear by itself or styled with more bracelets!\n\n• Measures: 6.5" + 2" extension\n\n• 18K gold plated over stainless steel component / accent pieces + genuine pearl shells heart beads.\n\n• Water resistant 💦\n\n• Hypoallergenic. Lead and nickel free.',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:58.670Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
